export const descriptionStyle = {
  marginBottom: '8px',
};

export const descriptionSkeletonStyle = {
  marginBottom: '8px',
};
